import { createContext } from 'react';

const DescriptionTemplatesContext = createContext();

export default DescriptionTemplatesContext;
